export default __webpack_public_path__ + "static/media/cards.1783c957.png";